import { render, staticRenderFns } from "./valid-time1.vue?vue&type=template&id=132e6afa&scoped=true&"
import script from "./valid-time1.vue?vue&type=script&lang=ts&"
export * from "./valid-time1.vue?vue&type=script&lang=ts&"
import style0 from "./valid-time1.vue?vue&type=style&index=0&id=132e6afa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e6afa",
  null
  
)

export default component.exports